import {
  rest,
  useUserInfo,
  useUserInfoContext,
} from '@xolv-mybrightlink/common';
import { useCallback } from 'react';

export const useEventSlaStatus = (): boolean => {
  const userInfo = useUserInfo();
  return userInfo.event_sla_acknowledged;
};

export const useAcceptEventSla = () => {
  const [, dispatch] = useUserInfoContext();
  return useCallback(async () => {
    await rest.post('/user/update-event-sla-acknowledgement');
    dispatch({ type: 'EVENT_SLA' });
  }, [dispatch]);
};
